const wowApp = require('angular').module('wowApp.shop');
wowApp.directive('bwsProductGroup', ['$stateParams', 'BreakpointsService', 'ProductGroupService', '$state', '$rootScope', require('./product-group-page-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/productgroup/index.js
 **/